// removed by extract-text-webpack-plugin
module.exports = {"Header_pageHeader":"Header__Header_pageHeader___2oYUK","Header_navPills":"Header__Header_navPills___1G-yA"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/stockStoreUpdate/components/Header.css
// module id = 1067
// module chunks = 0